@if (isLoadingOrder) {

  <div class="supplier-card">

    <div class="card-eyebrow">
      <ion-skeleton-text [animated]="true" style="width: 40%; height: 14px;"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" style="width: 60px; height: 20px; border-radius: 10px;"></ion-skeleton-text>
    </div>

    <div class="supplier-header">
      <div class="supplier-identity">
        <ion-thumbnail slot="start" class="loading-state">
          <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        </ion-thumbnail>

        <div class="identity-text" style="flex: 1 1 auto;">
          <ion-skeleton-text [animated]="true" style="width: 60%; height: 16px;"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="width: 40%; height: 12px;"></ion-skeleton-text>
        </div>
      </div>
    </div>

    <div class="lines">

      @for (row of [1, 2]; track row) {

        <div class="line">
          <ion-thumbnail slot="start">
            <ion-skeleton-text [animated]="true"></ion-skeleton-text>
          </ion-thumbnail>

          <div class="line-text" style="flex: 1 1 auto;">
            <ion-skeleton-text [animated]="true" style="width: 70%; height: 14px;"></ion-skeleton-text>
            <ion-skeleton-text [animated]="true" style="width: 45%; height: 12px;"></ion-skeleton-text>
          </div>

          <ion-skeleton-text [animated]="true" style="width: 48px; height: 28px; border-radius: 8px;"></ion-skeleton-text>
        </div>

      }

    </div>

    <div class="supplier-footer">
      <ion-skeleton-text [animated]="true" style="width: 100%; height: 40px; border-radius: 10px;"></ion-skeleton-text>
    </div>

  </div>

} @else if (!order) {

  <div class="supplier-card supplier-card--error">
    <div class="error-text">{{ 'ASSISTANT.PURCHASE_ORDER.ORDER_NOT_FOUND' | translate }}</div>
  </div>

} @else if (order) {

  <div class="supplier-card">

    <div class="card-eyebrow">
      <span class="eyebrow-label">
        <yu-icon name="sparkle" weight="light"></yu-icon>
        {{ 'ASSISTANT.PURCHASE_ORDER.EYEBROW' | translate }}
      </span>

      <yu-tag color="medium" size="small">
        {{ (linesCount === 1 ? 'ASSISTANT.PURCHASE_ORDER.PRODUCTS_COUNT_ONE' : 'ASSISTANT.PURCHASE_ORDER.PRODUCTS_COUNT_OTHER') | translate: {count: linesCount} }}
      </yu-tag>
    </div>

    <div class="supplier-header">
      <div class="supplier-identity">
        <ion-thumbnail slot="start">
          @if (order.proveedor_logo) {
            <img [src]="order.proveedor_logo" alt="--"/>

          } @else {
            <yu-icon name="package"></yu-icon>
          }
        </ion-thumbnail>

        <div class="identity-text">
          <div class="supplier-name">{{ order.proveedor }}</div>
          <div class="supplier-store">{{ order.local }}</div>
        </div>
      </div>
    </div>

    <div class="lines" [class.readonly]="isCreatingOrder || isCreated">

      @for (line of order.lineas; track line.id) {

        <div class="line">
          <ion-thumbnail slot="start">
            @if (line.foto) {
              <img [src]="line.foto" alt="--"/>

            } @else {
              <yu-icon name="bread"></yu-icon>
            }
          </ion-thumbnail>

          <div class="line-text">
            <div class="line-name">{{ line.nombre }}</div>
            <div class="line-format">{{ line.formato_ver }}</div>
          </div>

          <div class="qty-pill">
            <span class="qty-pill__times">&times;</span>

            <ion-input
              class="qty-pill__input"
              type="number"
              inputmode="decimal"
              [(ngModel)]="line.cantidad"
              (ionBlur)="saveLineQuantity(line)"
            ></ion-input>
          </div>
        </div>

      }

    </div>

    <div class="supplier-footer">

      @if (isCreated) {

        <div class="footer-created">
          <yu-button
            color="medium"
            type="outline"
            (yuClick)="shareOrder()"
          >
            <yu-icon name="share-network"></yu-icon>
          </yu-button>

          <yu-button
            expand="block"
            color="success"
            type="outline"
          >
            <yu-icon name="check-circle" weight="bold"></yu-icon>
            <span>{{ 'ASSISTANT.PURCHASE_ORDER.CREATED' | translate }}</span>
          </yu-button>
        </div>

      } @else {

        <yu-button
          expand="block"
          color="gradient"
          (yuClick)="createOrder()"
        >
          @if (isCreatingOrder) {
            <span>{{ 'ASSISTANT.PURCHASE_ORDER.CREATING' | translate }}</span>
            <ion-spinner slot="end" name="dots"></ion-spinner>

          } @else {
            {{ 'ASSISTANT.PURCHASE_ORDER.CREATE' | translate }}
          }
        </yu-button>

      }

    </div>

  </div>

}
